<div class="ralelaionship-container" [ngClass]="{'container-empty': noDataStyle === 'flex'&&windowSize<695 }">
    <div class="body-header">
        <div class="title body-header-title">Relationships</div>
        <div class="body-header-icon">
            <smart-icon class="angle-icon" name="meatball" (click)="onMeatball($event,$event)"></smart-icon>
        </div>
    </div>
    <div class="body-container">
        <div class="panel-tab">
            <tam-tab-set [selectedIndex]="selectedIndex" (selectChange)="selectChange($event)" [draggable]="false">
                <tam-tab *ngFor="let item of menuItems;trackBy:trackByFn" [title]="item" [disabled]="false"
                    [editable]="false" [editing]="false">
                </tam-tab>
            </tam-tab-set>
        </div>
        <div class="panel-content" (contextmenu)="mouseRightClickOnPanel($event)">
            <div class="data-container">
                <div class="no-data" [style.display]="noDataStyle">
                    <span>No Data</span>
                </div>
                <div *ngFor="let item of relationshipItems;let i = index; trackBy:trackByFn" class="sub-item-container">
                    <div *ngIf="item.title !== 'item-divider'" [ngStyle]="{'padding-top':i === 0 ? '8px' : '0px' }">
                        <div class="item-container" *ngIf="item.title">
                            <div class="one-item">
                                <div class="item-label body-3">
                                    <label class="active-relationship-type" *ngIf="item.title.clickable"
                                        (contextmenu)="mouseRightClick($event,item.title)">{{item.title.nodeDetail.name}}</label>
                                    <label *ngIf="!item.title.clickable">{{item.title.nodeDetail.name}}</label>
                                </div>
                                <div class="item-value body-1">
                                    <div class="dont-break-out"
                                        *ngFor="let itemValue of item.value;let i = index;trackBy:trackByFn">
                                        <span class="angular-with-newlines" class="active-span"
                                            (click)="onItemClick($event,itemValue)"
                                            (contextmenu)="mouseRightClick($event,itemValue)">
                                            {{itemValue.value}}
                                            <span *ngIf="i < item.value.length-1">, </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="item.title === 'item-divider'">
                        <hr class="item-divider" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <context-menu #meatballContextItemMenu>
        <ng-template contextMenuItem let-item (execute)="onMenuSelect($event)">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Activities</span>
            </div>
        </ng-template>

        <ng-template contextMenuItem let-item [subMenu]="screenSubMenu">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Contact Profile</span>
            </div>
            <smart-icon name="angle-right" class="angle-right-meatball">
            </smart-icon>
        </ng-template>
        <context-menu #screenSubMenu>
            <ng-template contextMenuItem *ngFor="let subMenu of contextMenu;trackBy:trackByFn"
                (execute)="onMenuSelect($event)">
                <div class="screen-sub-menu-container">
                    <span>{{subMenu.title}}</span>
                </div>
            </ng-template>
        </context-menu>

        <ng-template *ngIf="config.position !== 2 && config.position !== 4 && !isCollapse" contextMenuItem let-item
            (execute)="onMenuSelect($event)">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Collapse Tile</span>
            </div>
        </ng-template>
        <ng-template *ngIf="config.position !== 2 && config.position !== 4 && isCollapse" contextMenuItem let-item
            (execute)="onMenuSelect($event)">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Expand Tile</span>
            </div>
        </ng-template>
    </context-menu>

    <context-menu #contextItemMenu>
        <ng-template contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container" tid="view_details">
                <div class='empty'></div>
                <span class="context-menu-title">View Details</span>
            </div>
        </ng-template>
        <ng-template *ngIf="isEditDetailsShow" contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container" tid="edit_details">
                <div class='empty'></div>
                <span class="context-menu-title">Edit Details</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container" tid="new_note">
                <div class='empty'></div>
                <span class="context-menu-title">New Note</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem divider="true"></ng-template>

        <ng-template *ngIf="isChangeTypeMenuShow" contextMenuItem let-item [subMenu]="screenSubMenuRelationshipType">
            <div class="screen-menu-item-container" tid="change_relationship_type">
                <div class='empty'></div>
                <span class="context-menu-title">Change Type</span>
            </div>
            <smart-icon name="angle-right" class="angle-right" tid="change_type"></smart-icon>
        </ng-template>
        <context-menu #screenSubMenuRelationshipType>
            <ng-template contextMenuItem *ngFor="let subMenu of selectedItemValidRelationshipType; trackBy:trackByFn"
                (execute)="changeRelationshipType($event,subMenu)">
                <div class="screen-sub-menu-container" tid="change_item_type">
                    <span>{{subMenu.caption}}</span>
                </div>
            </ng-template>
        </context-menu>

        <ng-template *ngIf="isRemoveRelationshipMenuShow" contextMenuItem let-item
            (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container" tid="remove_relationship">
                <div class='empty'></div>
                <span class="context-menu-title">Remove Relationship</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem divider="true" *ngIf="isChangeTypeMenuShow || isRemoveRelationshipMenuShow">
        </ng-template>

        <ng-template *ngIf="isAddEntityMenuShow" contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty'></div>
                <span class="context-menu-title">Add Entity</span>
            </div>
        </ng-template>
        <ng-template *ngIf="isAddContactMenuShow" contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty'></div>
                <span class="context-menu-title">Add Contact</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem divider="true" *ngIf="isAddEntityMenuShow || isAddContactMenuShow"></ng-template>

        <ng-template *ngIf="isEditTeamMemberMenuShow" contextMenuItem let-item
            (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty'></div>
                <span class="context-menu-title">Edit Team Members</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem divider="true" *ngIf="isEditTeamMemberMenuShow"></ng-template>
        <ng-template contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container" tid="show_as_shortname">
                <div class='empty' *ngIf="!showAsShortNameChecked"></div>
                <smart-icon *ngIf="showAsShortNameChecked" name="check" class="checkIcon"></smart-icon>
                <span class="context-menu-title">Show as Shortname</span>
            </div>
        </ng-template>

        <ng-template contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container" tid="show_as_name">
                <div class='empty' *ngIf="!showAsNameChecked"></div>
                <smart-icon *ngIf="showAsNameChecked" name="check" class="checkIcon"></smart-icon>
                <span class="context-menu-title">Show as Name</span>
            </div>
        </ng-template>
    </context-menu>

    <!-- relationship type context menu-->
    <context-menu #relationshipTypeContextMenu>
        <ng-template *ngIf="isAddEntityMenuShow" contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty'></div>
                <span class="context-menu-title">Add Entity</span>
            </div>
        </ng-template>
        <ng-template *ngIf="isAddContactMenuShow" contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty'></div>
                <span class="context-menu-title">Add Contact</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem divider="true"></ng-template>
        <ng-template *ngIf="isEditTeamMemberMenuShow" contextMenuItem let-item
            (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty'></div>
                <span class="context-menu-title">Edit Team Members</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem divider="true" *ngIf="isEditTeamMemberMenuShow"></ng-template>
        <ng-template *ngIf="isRemoveAllRelationshipMenuShow" contextMenuItem let-item
            (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container" tid="remove_all_type">
                <div class='empty'></div>
                <span class="context-menu-title">Remove All of This Type</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem divider="true" *ngIf="isRemoveAllRelationshipMenuShow"></ng-template>
        <ng-template contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty' *ngIf="!showAsShortNameChecked"></div>
                <smart-icon *ngIf="showAsShortNameChecked" name="check" class="checkIcon"></smart-icon>
                <span class="context-menu-title">Show as Shortname</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty' *ngIf="!showAsNameChecked"></div>
                <smart-icon *ngIf="showAsNameChecked" name="check" class="checkIcon"></smart-icon>
                <span class="context-menu-title">Show as Name</span>
            </div>
        </ng-template>
    </context-menu>

    <!-- relationship panel's context menu-->
    <context-menu #relationshipPanelContextMenu>
        <ng-template *ngIf="isAddEntityMenuShow" contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty'></div>
                <span class="context-menu-title">Add Entity</span>
            </div>
        </ng-template>
        <ng-template *ngIf="isAddContactMenuShow" contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty'></div>
                <span class="context-menu-title">Add Contact</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem divider="true" *ngIf="isAddEntityMenuShow || isAddContactMenuShow"></ng-template>
        <ng-template *ngIf="isEditTeamMemberMenuShow" contextMenuItem let-item
            (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty'></div>
                <span class="context-menu-title">Edit Team Members</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem divider="true" *ngIf="isEditTeamMemberMenuShow"></ng-template>
        <ng-template contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty' *ngIf="!showAsShortNameChecked"></div>
                <smart-icon *ngIf="showAsShortNameChecked" name="check" class="checkIcon"></smart-icon>
                <span class="context-menu-title">Show as Shortname</span>
            </div>
        </ng-template>

        <ng-template contextMenuItem let-item (execute)="onRelationshipMenuSelect($event)">
            <div class="screen-menu-item-container">
                <div class='empty' *ngIf="!showAsNameChecked"></div>
                <smart-icon *ngIf="showAsNameChecked" name="check" class="checkIcon"></smart-icon>
                <span class="context-menu-title">Show as Name</span>
            </div>
        </ng-template>
    </context-menu>
</div>